module.exports = {

    'OLD_PASSWORD': 'Old password',
    'OLD_PASSWORD_REQUIRED': 'Old password is required',
    'OLD_PASSWORD_NOT': 'Old password is incorrect',
    'NEW_PASSWORD': 'New password',
    'NEW_PASSWORD_REQUIRED': 'New password is required',
    'CONFIRM_PASSWORD': 'Confirm password',
    'CONFIRM_PASSWORD_REQUIRED': 'Confirm password is required',
    'CONFIRM_PASSWORD_SAME': 'Passwords must be the same',

    // NG-Admin
    'BACK': 'Back',
    'DELETE': 'Delete',
    'CREATE': 'Create',
    'EDIT': 'Edit',
    'EXPORT': 'Export',
    'ADD_FILTER': 'Add filter',
    'SEE_RELATED': 'See all related {{ entityName }}',
    'LIST': 'list',
    'SHOW': 'Show',
    'SAVE': 'Save',
    'N_SELECTED': '{{ length }} Selected',
    'ARE_YOU_SURE': 'Are you sure?',
    'YES': 'Yes',
    'NO': 'No',
    'FILTER_VALUES': 'Filter values',
    'CLOSE': 'Close',
    'CLEAR': 'Clear',
    'CURRENT': 'Current',
    'REMOVE': 'Remove',
    'ADD_NEW': 'Add new {{ name }}',
    'BROWSE': 'Browse',
    'N_COMPLETE': '{{ progress }}% Complete',
    'CREATE_NEW': 'Create new',
    'SUBMIT': 'Submit',
    'SAVE_CHANGES': 'Save changes',
    'BATCH_DELETE_SUCCESS': 'Elements successfully deleted',
    'DELETE_SUCCESS': 'Element successfully deleted',
    'ERROR_MESSAGE': 'Oops, an error occurred (code: {{ status }})',
    'INVALID_FORM': 'Invalid form',
    'CREATION_SUCCESS': 'Element successfully created',
    'EDITION_SUCCESS': 'Changes successfully saved',
    'ACTIONS': 'Actions',
    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
    'NO_PAGINATION': 'No record found',
    'PREVIOUS': '« Prev',
    'NEXT': 'Next »',
    'DETAIL': 'Detail',
    'STATE_CHANGE_ERROR': 'State change error: {{ message }}',
    'NOT_FOUND': 'Not Found',
    'NOT_FOUND_DETAILS': 'The page you are looking for cannot be found. Take a break before trying again.',

    //lang
    'SPANISH' : "Spanish",
    'ENGLISH' : "English",
    'CATALAN' : "Catalan",

    //Menu
    'ORDERS' : "Orders",
    'ACCOUNT' : "Account",
    'PURCHASES' : "Purchases",
    'DOWNLOADS' : "Downloads",
    'USERS' : "Users",
    'USER_LIST' : "Patients list",
    'PRENSCRIBER_LIST' : "Profesionals lists",
    'COMPANY_LIST' : "Company list",
    'PRESCRIBER_TYPES' : "Prescriber Types",
    'PRODUCTS' : "Products",
    'SUBSCRIPTIONS': "Subscriptions",
    'LICENCES': "licences",
    'LICENCES_TEXT': 'All licenses are subject to annual maintenance and the signing of a contract',
    'GAMES': "Games",
    'CONFIG': "Config",
    'VARIABLES': "Variables",
    'ABILITIES': "Abilities",
    'LOGOUT': "Logout",
    'PRESNCRIPTORS': 'Prescriptors',
    'PROFESSIONAL_MANUAL': "Professional's manual",
    'PROFESSIONAL_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/manual_profesional_eng.pdf',
    'USER_MANUAL': "User's guide",
    'USER_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/guia_usuario_cast.pdf',
    'VIDEOS_TUTORIAL': 'Tutorial videos',

    // Login
    'REGISTER': "Register",
    'LOGIN': "Login",
    'USERNAME_OR_EMAIL': "Username",
    'RECOVERY_PASSWORD': "Recovery password",
    'USERNAME_EMAIL_RECOVERY': "Username is required.",
    'PASSWORD_REQUIRED': "Password is required.",
    'LETS_GO': "Let's go",
    'PASSWORD': "Password",
    'ERROR_USSER_PASSWORD_INCORRECT': "Username or password is incorrect",
    'LOGIN_REGISTER': "Sign up",
    'OR': "or",
    'ERROR_LINK_EXPIRED': 'The link to retrieve password has expired, please request another one',

    //Recovery
    'SIGN_IN_AGAIN': "Sign in again",
    'INTERNAL_ERROR': "Internal error",
    'Invalid username or email': "Invalid username",
    'Password request alerady requested': "Password request alerady requested",
    'SEND_EMAIL_REQUEST_SUCCESS': "We have sent you an email with the steps to reset the password",

    //Register
    'USER': "User",
    'USERNAME': "Username",
    'USERNAME_REASON': 'The username will be used so that we can identify you on the login screen',
    'PRESCRIBER': "Prescriber",
    'USERNAME_REQUIRED': "Username is required",
    'ACCEPT_TERMS_SERVICE': "I accept the terms of service",
    'YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED': "You must accept the terms of service before you can proceed",
    'USERNAME_ALREADY_TAKEN': "Username already taken",
    'CREATED_CHECK_YOUR_EMAIL': 'Your account has been created successfully, check your email.',
    'MALFORMET_DATA': 'Malformet data',
    'PASSWORD_SHORT': 'The password is too short',

    //Account
    'MANAGE_LICENCES': "Manage Licences",
    'YOU_ARE': "User type",
    'YOUR_LICENCES': "Your licences",
    'YOUR_SUBSCRIPTIONS': "Your subscriptions",
    'NEED_MORE_LICENCES': "Need more licences?",
    'PURCHASE_LICENCES': "Purchase licences",
    'PURCHASE_SUBSCRIPTIONS': "Buy Subscriptions",
    'ADD_LICENCE': "Add licence",
    'RECHARGE_SUBSCRIPTIONS': "Recharge subscriptions",
    'ACTIVE_UNUSED': "active / unused",
    'MANAGE_SUSCRIPTIONS': "Manage suscriptions",
    'ADD_SUSCRIPTIONS': "Add suscriptions",
    'ORDERS_INVOICES': "Orders & Invoices",
    'YOUR_LAST_PAYMENT': "Your last payment, of",
    'WAS_MADE_ON': "was made on",
    'SHOW_ORDERS': "Show orders & invoices",

    //Licences
    'LICENCE': "Licence",
    'ASSIGNED_TO': "Assigned to",
    'EXPIRATION_AT': "Expiration at",
    'MAC': "Mac",
    'REASSIGN_THIS_LICENCE': "Reassign this licence",
    'CHOOSE_AN_USER': "Choose an user",
    'SELECT_AN_USER': "Select an user",
    'REVOKE_MAC_LICENCE': "Revoke this mac licence",
    'REASSIGN': "Reassign",
    'REMOVE_YOUR_LICENCE_LINK': "Would you like to remove your licence link?",
    'REMOVE_YOUR_LICENCE_LINK_TEXT': "By removing the license link you could use this license on another computer. <br>' + 'Note that the new computer will be linked to this license",
    'LUCKY_DAY': "Lucky day",
    'SUCCESS_REMOVE_LICENCE': "Your licence link has been removed",
    'MANUAL_INVOICE': 'Manual Invoice',
    'NO_LICENCE': 'You need an active license',
    'NO_LICENCE_BUY': 'Please buy a license',

    //Purchases
    'SELECT_PRODUCT': "Select a product",
    'PROMOTIONAL_CODE': "Do you have a promotional code?",
    'CODE_DOES_NOT_PROMOTION': "The code does not have any promotion",
    'TOTAL_ITEMS': "Total Items",
    'TAXES': "Taxes",
    'AMOUNT_PAYABLE': "Amount payable",
    'USE_MY_ACCOUNT_INFORMATION_INVOICE': "Use my account information for the invoice",
    'USE_OTHER_INFORMATION_INVOICE': "Use other information for the invoice",
    'NAME': "Name",
    'NAME_REQUIRED': "Name is required",
    'SURNAME': "Surname",
    'SURNAME_REQUIRED': "Surname is required",
    'COMPANY': "Company",
    'CIF/NIF': "CIF/NIF",
    'CIF_NIF_REQUIRED': "CIF or NIF is required",
    'ADDRESS': "Address",
    'ADDRESS_REQUIRED': "Address is required",
    'COMPANY_REQUIRED': "Company is required",
    'POSTAL_CODE': "Postal Code",
    'CITY': "City",
    'STATE': "State",
    'COUNTRY': "Country",
    'YOU_SUPPLY_POSTAL_CODE': "You must supply a postal code",
    'THAT_DOESNT_LOOK_LIKE_VALID_PC': "That doesn't look like a valid postal code",
    'BUY_LICENCE': "Buy",
    'BUY_SUSCRIPTIONS': "Buy",
    'ORDER': "Order",
    'YOU_MUST_MAKE_BANK_TRANSFER': "You must make a bank transfer to",
    'WITH_THE_CONCEPT': "with the concept",
    'PAY_WITH_PAYPAL': "Pay with Paypal",
    'PAY_WITH_CREDIT_CARD': "Pay with credit card",
    'PAY_WITH_WIRE_TRANSFER': "Pay with wire transfer",
    'SELECT_METHOD': "Select a method",
    'YOU_DONT_HAVE_PERMISSION_AREA': "You don't have permission in this area",
    'UNIT_PRICE': "The unit comes out",
    'YOUR_PENDING_REMOVED':"Your pending purchase has been removed",
    'CONFIRM_REMOVE_PURCHASE_PENDING':"Would you like to remove this pending purchase?",
    'CANCEL':"Cancel",
    'REMOVE!':"Remove!",
    'BUY_SUCCESS': "Your order has been processed correctly.",
    'CIF_NIF_ALREADY_EXISTS': "The cif/nif/nie already exists",
    'CIF_NIF_INVALID' : "The cif/nif/nie is invalid",
    'PHONE_REQUIRED': "The phone is requierd",
    'ADDRESS_REQUIRED': "The address is requierd",
    'CITY_REQUIRED': "The city is requied",

    //ERRORS
    'PLEASE_INSERT_NUMERIC_VAL':"Si us plau, introduïu un valor numèric!",
    'NOT_ENOUGH_SUBS':"You do not have enough subscriptions",
    'USER_HAS_NOT_SUBS':"This user has not subscription",
    'UNAUTORITHED':"Unautorithed",
    'INVALID_DETAILS_IN_FORM':"Some values are invalid, see details in the form",

    //thanks
    'THANK_YOU': "Thank you",
    'THE_PURCHASE_WAS_MADE_CORRECTLY': "The purchase was made correctly, you can manage your purchases in the section of your account",

    //Error
    'ERROR': "Error",
    'COULD_NOT_COMPLETE_PURCHASE': "Could not complete purchase",

    //Profile
    'PROFILE': "Profile",
    'EMAIL': "Email",
    'EMAIL_REQUIRED': "Email is required",
    'EMAIL_NOT_VALID': "Email is not valid",
    'EMAIL_ALREADY_TAKEN': "Email already taken or is not valid",
    'BIRTHDAY': "Birthdate",
    'MATURATIVE_AGE' : 'Maturative age',
    'BIRTHDAY_REQUIRED': "Birthday is required",
    'PRESCRIBER_TYPE': "Prescriber Type",
    'PRESCRIBER_TYPE_REQUIRED': "Prescriber type is required",
    'UPDATE_MY_DATA': "Update my data",
    'CHANGE_PASSWORD': "Change password",
    'PROFILE_UPDATE': "Your profile has been updated",

    //Subscriptions
    'MANAGE_SUBSCRIPTIONS': "Manage Subscriptions",
    'PRESCRIPTOR': "Prescriptor",
    'PATIENT': "Patient",
    'PATIEN_EMAIL': "Patien Email",
    'STATUS': "Status",
    'NUM_SUBSCRIPTIONS': "Num of subscriptions",
    'EXPIRATE_AT': "Expirate at",
    'LINK_SUBSCRIPTION': "Link a new subscription",
    'UNLINK_SUBSCRIPTION': "Unlink this subscription",
    'ADD_SUBSCRIPTION': "Add more subscriptions",
    'NO_SERS_YET': "No users yet",
    'WOULD_LIKE_ADD_NEW_USER': "Would you like add a new user?",
    'active': 'Active',
    'inactive': 'Inactive',
    'MODAL_CANCEL' : 'Cancel',
    'ADD_SUBSCRIPTION_TITLE' : 'How many months do you want to have a subscription?',
    'ADD_SUBSCRIPTION_CONTENT' : "Each subscription unit is equivalent to 1 month. <br> If you want a user to have 3 months of subscription add 3. <br> Note: that each unit consumes a subscriber of the total.",
    'ADD_SUBSCRIPTION_INPUT' : 'Number of subscriptions',
    'ADD_SUBSCRIPTION_SUCCESS' : "The subscription link has been added",
    'ADD_SUBSCRIPTION_BUTTON' : 'Add subscription!',
    'REMOVE_SUBSCRIPTION_TITLE' : 'Would you like to remove the subscription link?',
    'REMOVE_SUBSCRIPTION_CONTENT' : 'By removing the subscription link the user will no longer have access immediately.',
    'REMOVE_SUBSCRIPTION_BUTTON' : 'Remove!',
    'REMOVE_SUBSCRIPTION_SUCCESS' : "Your subscription has been successfully deleted",
    'NO_USERS_YET' : "No users yet",
    'ENOUGH_SUBSCRIPTION_TITLE': 'You do not have enough subscriptions',
    'ENOUGH_SUBSCRIPTION': 'You do not have more subscriptions to assign. <br> Buy more or notify your administrator.',
    'OK': 'ok',
    'LAST_ASSINGED': 'Last assignment',

    //Invoices
    'INVOICES': "Invoices",
    'PRODUCT': "Product",
    'AMOUNT': "Amount",
    'DATE': "Date",
    'DOWNLOAD_INVOICE': "Download invoice",
    'NO_PURCHASE_YET': "No purchase yet",
    'PENDING_ORDERS': "Pending orders",
    'MAKE_PAYMENT_NOW': "Make payment now",
    'REMOVE_PENDING_ORDER': "Remove this pending order",
    'PAYMENTS': 'Payments',
    'PAYMENT': 'Payment',

    //summary
    'MONTHLY_REVENUE': "Monthly Revenue",
    'VIEW_DETAILS': "View Details",
    'PENDING_REVIEWS': "Pending reviews",
    'NEW_CUSTOMERS': "New customers",

    //Products
    'ABBR': "Abbr",
    'PRICE': "Price",
    'PRICE_MONTH': "Total price",
    'ENROLLMENT': "Enrollment",
    'PROMOTIONAL': "Promotional",
    'TYPE': "Type",
    'UNITS': "Units",
    'GAME': "Game",

    //Variables
    'ABBREVIATION': "Abbreviation",
    'DESCRIPTION': 'Description',
    'FLOAT': "Float",
    'INTEGER': "Integer",
    'BOOLEAN': "Boolean",
    'MULTIPLE': "Multiple",
    'REPETITIONS': "Repetitions",
    'MODIFY_FIXED': "Modify Fixed",
    'MODIFY_RELATION': "Modify Relation",
    'HARDNESS_INITIAL': "Hardness Initial",
    'MODIFY_VARIABLE': "Modify Variable",
    'STEPS': "Steps",
    'KEY': "Key",
    'VALUE': "Value",

    //Game
    'WEIGHT': "Weight",
    'ABILITY': "Ability",
    'PERCENTAGE': "Percentage",
    'ADD': "Afegir",
    'VARIABLE': "Variable",
    'INCLUDED' : "Included",
    'ONLY_GOLD': 'Only visible in PRO GOLD',
    'VISIBLE_AUTOMATIC':'NO visible in automatic therapy',

    //Entities
    'ID': "Id",
    'FINALIZED': "Finalized",
    'IDENTIFIER': "Identifier",
    'IP': "Ip",
    'METHOD': "Method",
    'UPDATED': "Updated",
    'PAYPAL': "PayPal",
    'CREDIT_CARD': "Credit Card",
    'WIRE_TRANSFER': "Wire Transfer",
    'SUBSCRIPTION': "Subscription",
    'CODE': "Code",

    //User
    'user': "user",
    'Users': "Users",
    'ENABLED': "Enabled",
    'CREATED': "Created",
    'ROLES': "Roles",
    'WORKERS': "Workers",
    'PATIENTS': "Patients",
    'CIF': "Cif",
    'TRAINING_TIME_MIN': "Training Time (min)",
    'TRAINING_TIME': "Training Time",
    'TRAINING_DATE': "Training Date",
    'USER_TEST': "Test User",

    //Download
    'DOWNLOAD' : 'Download',
    'TEXT_DOWNLOAD' : 'Download here your application manager',
    'USER_VISUAL_WINDOWS': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/user_visual_guide_windows_en.pdf',
    'USER_VISUAL_ANDROID': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/user_visual_guide_android_en.pdf',
    'INSTALL_WINDOWS': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/sport_install_guide_windows_es.pdf',
    'INSTALL_ANDROID': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/sport_install_guide_windows_es.pdf',
    'USER_GUIDE_LABEL': 'Visual Guide',
    'INSTALL_LABEL': 'Installation Guide',

    //Licences VR
    'LICENCES_GAME_VR' : 'Licences GAME VR',

    //Events
    'EVENTS' : 'Events',
    'LOCATION': 'Location',
    'LOCATION_MAP': 'Location in google maps',
    'INTERESTED': 'Interested',
    'IMAGE': 'Image',
    'PHONE': 'Phone',

    // Promo
    'PROMO_UNAVAIABLE': 'The free trial has already been used',
    'PROMO_REQUEST': 'Request your free trial',
    'PROMO_REGISTER' : 'Registration free trial',
    'PROMO_CREATED_CHECK_YOUR_EMAIL' : 'We have sent you the following steps by email.',
    'PROMO_PROBLEM_TITLE': "There was an error",
    'PROMO_PROBLEM_TEXT': "Errors have been detected and you can not continue registration for the free trial, <br>please send an email to <a href=\"mailto:info@brainvt.com?Subject=Error for free trial\">info@brainvt.com</a> or by calling"
};


/** WEBPACK FOOTER **
 ** ./js/languages/en.js
 **/